import * as React from 'react';
import { Card } from '@grandvisionhq/common';
import { OpeningHours } from '@grandvisionhq/locations';
import { useIntl } from '@grandvisionhq/state';

const LocationInfo = ({ isStore , isStorePickupPhoneEnabled , location , message , onEdit , hasOpeningHours =true , title  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(Card, {
        className: "checkout-location-info",
        "data-t": "locationInfoSummary"
    }, /*#__PURE__*/ React.createElement(Card.Content, null, onEdit && /*#__PURE__*/ React.createElement(Card.Actions, null, /*#__PURE__*/ React.createElement(Card.Button, {
        onClick: onEdit,
        children: getLabel('common.actions.edit')
    })), /*#__PURE__*/ React.createElement(Card.Section, null, title && /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head",
        className: "checkout-step--overview__caption"
    }, title), /*#__PURE__*/ React.createElement(Card.Text, {
        color: "text-secondary",
        variant: "caption"
    }, location.name), /*#__PURE__*/ React.createElement(Card.Text, {
        color: "text-secondary",
        variant: "caption"
    }, location.streetName, location.streetNumber && ` ${location.streetNumber}`, location.additionalStreetInfo && ` ${location.additionalStreetInfo}`), /*#__PURE__*/ React.createElement(Card.Text, {
        color: "text-secondary",
        variant: "caption"
    }, location.postalCode, " ", location.town)), isStorePickupPhoneEnabled && isStore(location) && /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(Card.Text, null, /*#__PURE__*/ React.createElement("a", {
        href: `tel:${location.phone}`
    }, location.phone))), message, hasOpeningHours && isStore(location) && /*#__PURE__*/ React.createElement(Card.Text, null, /*#__PURE__*/ React.createElement(OpeningHours, {
        openingHours: location.openingHours
    }))));
};

export { LocationInfo };
//# sourceMappingURL=LocationInfo.js.map
